module.exports = __webpack_public_path__ + "static/img/1.97b7072.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/eng/1.png
// module id = QXAF
// module chunks = 0